import { rtlLine } from "./table-shape";

/**
 * A NEWER COPY OF THE PLAYER'S APP TAKES THEIR SEAT BACK (card-74, the operator 2026-10-20).
 *
 * «When a player opens the game again while an older copy of their app still holds their seat, the
 * new copy must get the seat back — at any point in the match, public or private — and the old copy
 * is let go.» The order between two copies is the LAUNCH: Telegram signs a fresh `auth_date` into the
 * initData of every open of the Mini App (a reload or a minimise keeps the one it has), and the
 * game-server reads it off the validated initData every join already carries — so the newest launch
 * wins with no help from the client, and a superseded launch is refused at every door that seats a
 * socket (`apps/game-server/src/rooms/seat-takeover.ts`).
 *
 * Two values cross the wire between the game-server and the web bundle, so each is a contract
 * between two IMAGES (CLAUDE.md «A STRING MATCHED ACROSS THE WIRE IS A CONTRACT BETWEEN TWO IMAGES»):
 */

/**
 * The close code the game-server sends the copy it lets go. A bundle that knows it treats it as final
 * (no reconnect, one short notice); a bundle cached before this reads it as a dropped socket, and its
 * reconnect is then refused — the seat is not its own any more — so it can never take the seat back.
 * Outside colyseus's own codes (4000 consented, 4002 error, 4010 dev restart) and outside the
 * 4210–4299 matchmake-error window the web reads as «seat gone».
 */
export const SEAT_TAKEN_OVER_CLOSE_CODE = 4100;

/**
 * The matchmake method (`POST /matchmake/takeover/<roomId>`, body `{ initData }`) a NEW bundle's return
 * to a saved table asks when its ticket is refused `4214` — the one refusal an older copy still holding
 * the seat produces. It reserves a seat ONLY for a player who already holds a chair at that table, so it
 * can never seat anyone new; an older game-server answers it «invalid method», and the return goes on
 * exactly as before.
 */
export const SEAT_TAKEOVER_METHOD = "takeover";

/**
 * WHERE A `takeover` REQUEST COMES FROM (card-74 round 2, #4) — its body's `origin`, which the
 * game-server puts on the takeover's `Event` row and log line so a count can tell them apart:
 * `reconnect` — the page's OWN reconnect asking the door after its first 4214 (review #1b): mostly the
 * page's own half-open socket the server has not noticed yet (~650 in 14 days), an ordinary reconnect,
 * not a newer copy; `return` — a copy opening the saved table («ادامه بازی», the straight-back, the
 * crash screen); `held` — the «بازی عمومی» refusal's way back to the seat the game-server named (card-9f,
 * `HELD_SEAT_METHOD`): the ONE origin that may also be handed a BOT-HELD chair's own reservation, and only
 * at a public table. The server labels the locked room's joinById door and an ordinary join `join` itself.
 * Otherwise a label: an older game-server reads `held` as `return`.
 */
export const SEAT_TAKEOVER_ORIGINS = ["reconnect", "return", "held"] as const;
export type SeatTakeoverOrigin = (typeof SEAT_TAKEOVER_ORIGINS)[number];

/**
 * WHAT THE COPY THAT WAS LET GO READS — the operator, 2026-10-20: «an accurate message — that the game
 * moved to the newer window — not «جات به ربات سپرده شد»». One sentence everywhere: the web's
 * `fa.online.takenOver`, and what the game-server sends that copy as an ERROR frame (a bundle deployed
 * before this change shows a Persian error verbatim) and answers a superseded join with. Marked at both
 * ends (`rtlLine`) so its «.» stays at the left end under any paragraph direction.
 */
export const SEAT_MOVED_MESSAGE = rtlLine("بازی به پنجره‌ی تازه‌تر منتقل شد.");
